import { render, staticRenderFns } from "./SearchTags.vue?vue&type=template&id=49a85a30&"
import script from "./SearchTags.vue?vue&type=script&lang=js&"
export * from "./SearchTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports